import { FormScoreDetailsComponent } from './form-score-details.component';

export default angular
  .module('sfMobile.components.form-score-details', ['sfMobile.services.dates'])
  .component('sfFormDetailsScore', FormScoreDetailsComponent).name;
